module.exports = __webpack_public_path__ + "img/wk3.1534a686.jpg";